import { ROUTES_NAME } from "../../../config/constants";
import { ACCESS_TOKEN } from "../../../constants";
import { authenticatedFetch } from "../../../util/authenticatedFetch";
import {
  REINDEXING_REQUEST,
  REINDEXING_ERROR,
  REINDEXING_SUCCESS,
  REINDEXING_RESET,
  CANCEL_DIGITAL_ORDER_ERROR,
  CANCEL_DIGITAL_ORDER_REQUEST,
  CANCEL_DIGITAL_ORDER_SUCCESS,
  CANCEL_DIGITAL_ORDER_RESET,
} from "./ActionType";

const readResponsePayload = async (response) => {
  if (typeof response.text === "function") {
    const text = await response.text();
    if (!text) return null;

    try {
      return JSON.parse(text);
    } catch (_error) {
      return { message: text };
    }
  }

  if (typeof response.json === "function") {
    try {
      return await response.json();
    } catch (_error) {
      return null;
    }
  }

  return null;
};

const responseErrorMessage = (payload, response, fallback) => {
  const serverMessage =
    (typeof payload === "string" && payload) ||
    [payload?.message, payload?.error, payload?.detail].find(
      (value) => typeof value === "string" && value.trim()
    );

  return serverMessage || `${fallback} (${response.status})`;
};

const requestHeaders = () => ({
  Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN),
  "Content-Type": "application/json",
  Origin: `${process.env.REACT_APP_URL}`,
});

let requestSequence = 0;

const createRequestMeta = (operation, shopId) => {
  const normalizedShopId = String(shopId);
  requestSequence += 1;

  return {
    shopId: normalizedShopId,
    requestId: `${operation}:${normalizedShopId}:${Date.now()}:${requestSequence}`,
  };
};

export const getReIndexStore = (shopId) => {
  return async (dispatch) => {
    const meta = createRequestMeta("reindex", shopId);
    dispatch(reindexRequest(meta));
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.reindexing(shopId)}`;

    try {
      const response = await authenticatedFetch(url, {
        method: "POST",
        credentials: "include",
        headers: requestHeaders(),
      });
      const payload = await readResponsePayload(response);

      if (!response.ok) {
        throw new Error(
          responseErrorMessage(payload, response, "Store reindex request failed")
        );
      }

      dispatch(reindexSuccess(payload, meta));
      return { ok: true, payload };
    } catch (error) {
      const message = error?.message || "Store reindex request failed";
      dispatch(reindexError(message, meta));
      return { ok: false, error: message };
    }
  };
};

export const postCancelDigitalOrder = (shopId) => {
  return async (dispatch) => {
    const meta = createRequestMeta("cancelDigitalOrders", shopId);
    dispatch(cancelDigitalOrderRequest(meta));
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.cancelDigitalOrder(shopId)}`;

    try {
      const response = await authenticatedFetch(url, {
        method: "POST",
        credentials: "include",
        headers: requestHeaders(),
      });
      const payload = await readResponsePayload(response);

      if (!response.ok) {
        throw new Error(
          responseErrorMessage(
            payload,
            response,
            "Cancel digital orders request failed"
          )
        );
      }

      dispatch(cancelDigitalOrderSuccess(payload, meta));
      return { ok: true, payload };
    } catch (error) {
      const message = error?.message || "Cancel digital orders request failed";
      dispatch(cancelDigitalOrderError(message, meta));
      return { ok: false, error: message };
    }
  };
};

export const resetReindex = () => ({ type: REINDEXING_RESET });

export const resetCancelDigitalOrder = () => ({
  type: CANCEL_DIGITAL_ORDER_RESET,
});

function reindexRequest(meta) {
  return { type: REINDEXING_REQUEST, meta };
}

function reindexSuccess(data, meta) {
  return { type: REINDEXING_SUCCESS, payload: data, meta };
}

function reindexError(data, meta) {
  return { type: REINDEXING_ERROR, payload: data, meta };
}

function cancelDigitalOrderRequest(meta) {
  return { type: CANCEL_DIGITAL_ORDER_REQUEST, meta };
}

function cancelDigitalOrderSuccess(data, meta) {
  return { type: CANCEL_DIGITAL_ORDER_SUCCESS, payload: data, meta };
}

function cancelDigitalOrderError(data, meta) {
  return { type: CANCEL_DIGITAL_ORDER_ERROR, payload: data, meta };
}
